import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { MessageType } from '@caslink/common-client';
import { DialogConfirmOptions } from '@caslink/common-client/src/typings/models';
import { ThemeService } from '@caslink/common-client/ng-app/theme/ThemeService';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';

import { ControlSettingTemplatesService } from '../shared/services/control-setting-templates.service';
import { ToastService } from '@captiveaire/toast';


interface UpdateConfirmationDialogData {
    dialogConfirmOptions: DialogConfirmOptions;
    preview: CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel;
}

@Component({
    selector: 'dl-update-confirmation-dialog',
    template: `
        <popup-header [titleIcon]="data.dialogConfirmOptions.titleIcon"
                      [icon]="icon"
                      (clickAction)="cancelAction()"
                      [text]="data.dialogConfirmOptions.title">
        </popup-header>





        <div id="" style="overflow:auto; height:250px; width:780px; ">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="template-tree">
              <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                <li class="mat-tree-node">
                  <button mat-icon-button disabled></button>
                  {{node.displayText}}
                </li>
              </mat-tree-node>
              <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                <li>
                  <div class="mat-tree-node">
                    <button mat-icon-button matTreeNodeToggle
                            [attr.aria-label]="'toggle ' + node.name">
                      <mat-icon class="mat-icon-rtl-mirror">
                        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                      </mat-icon>
                    </button>
                    {{node.displayText}}
                  </div>
                  <ul [class.template-tree-invisible]="!treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                  </ul>
                </li>
              </mat-nested-tree-node>
            </mat-tree>
        </div>





        <div class="message-content">
            {{ data.dialogConfirmOptions.message }}
        </div>

        <div class="message-content">
                    <mat-form-field class="full-width">
                        <mat-label>Service Note (required)</mat-label>
                        <textarea matInput type="text" [formControl]="noteFormControl" (change)="noteChanged()" cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="2"></textarea>
                    </mat-form-field>
        </div>

        <popup-button-container>
            <cas-button [color]="null" [hidden]="!showCancelBtn" [btnText]="cancelBtnText" (clickAction)="cancelAction()"></cas-button>

            <cas-button [disabled]="!noteFormControl.value" btnClass="md-raised md-accent {{ isWarning ? 'md-warn' : '' }}"
                        (clickAction)="confirmAction()"
                        [btnText]="confirmBtnText">
            </cas-button>
        </popup-button-container>
    `,
    styles: [
        `
        div[mat-dialog-content] {
          padding: 20px;
        }

        .template-tree-invisible {
          display: none;
        }

        .template-tree ul,
        .template-tree li {
          margin-top: 0;
          margin-bottom: 0;
          list-style-type: none;
        }

        :host .message-content {
            padding: 24px;
        }

        `
    ]
})
export class UpdateConfirmationDialogComponent implements OnInit {
    public isWarning: boolean;
    public confirmBtnText: string;
    public showCancelBtn: boolean;
    public cancelBtnText: string;
    public toolbarClass: string;

    public icon: string;

    protected note: string;
    public noteFormControl: FormControl;
    public formGroup: FormGroup;

    treeControl = new NestedTreeControl<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesNodeViewModel>(node => node.children);
    dataSource = new MatTreeNestedDataSource<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesNodeViewModel>();

    constructor(
        private dialogRef: MatDialogRef<UpdateConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: UpdateConfirmationDialogData,
        private themeService: ThemeService
    ) {
    }

    hasChild = (_: number, node: CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesNodeViewModel) => !!node.children && node.children.length > 0;

    public ngOnInit() {

        this.formGroup = new FormGroup({});
        this.noteFormControl = new FormControl(this.note, [Validators.required]);
        this.formGroup.addControl('note', this.noteFormControl);


        this.toolbarClass = this.themeService.getBackgroundPrimaryClassHue2();
        this.icon = this.mapIcon();
        this.isWarning = this.data.dialogConfirmOptions.messageType === MessageType.Warning;
        this.confirmBtnText = this.data.dialogConfirmOptions.confirmBtnText || 'Yes';
        this.cancelBtnText = this.data.dialogConfirmOptions.cancelBtnText || 'Cancel';
        this.showCancelBtn = !_.isUndefined(this.data.dialogConfirmOptions.showCancelBtn) ? this.data.dialogConfirmOptions.showCancelBtn : true;

        this.dataSource.data = this.data.preview.templateTree;

        this.treeControl.dataNodes = this.data.preview.templateTree;

        this.treeControl.expandAll();

    }

    noteChanged() {
        this.note = this.noteFormControl.value;
    }

    public confirmAction() {
        this.dialogRef.close(this.note);
    }

    public cancelAction() {
        this.dialogRef.close(null);
    }

    private mapIcon() {
        if (this.data.dialogConfirmOptions.messageType === MessageType.Warning) {
            return 'warning';
        }

        return 'info_outline';
    }
}


